var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXrpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 368,
    viewBox: "0 0 424 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.549 0H211.212L147.418 66.1679C124.326 90.1199 86.8857 90.1199 63.7933 66.1679L1.04176e-08 0H30.6624L79.1246 50.2661C93.7497 65.4356 117.461 65.4356 132.087 50.2661L180.549 0Z",
    transform: "translate(0.792969) scale(2)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6625 84.5407H0L64.1874 17.9639C87.2798 -5.98797 124.72 -5.98797 147.813 17.9639L212 84.5407H181.337L132.481 33.8655C117.855 18.6958 94.1438 18.6958 79.5187 33.8655L30.6625 84.5407Z",
    transform: "translate(0 198.919) scale(2)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrpLogo);
export default __webpack_public_path__ + "static/media/xrp_logo.f7a11feba0a4af9c270e0d41456034bf.svg";
export { ForwardRef as ReactComponent };